import PropTypes from "prop-types";
import styles from "./index.css";
import classNames from "classnames";

export const BULLET_SYMBOL = " \u2022 ";

const CategoryHeaderRibbon = ({ className, ribbonText }) => (
  <div
    aria-hidden="true"
    className={classNames("london4", styles.ribbon, className)}
  >
    {new Array(50).fill(null).map((_, index) => (
      <span key={index}>
        {ribbonText}
        {BULLET_SYMBOL}
      </span>
    ))}
  </div>
);

CategoryHeaderRibbon.propTypes = {
  className: PropTypes.string,
  ribbonText: PropTypes.string.isRequired
};

export default CategoryHeaderRibbon;
